const defaultState = () => {
  return {
    bdxFilters: {
      companyId: null,
      companyRoleName: 'admin',
      companyRoleValue: 'admin'
    },
    userCompanyRLS: {
      id: null,
      slipshare: null
    }
  }
}

const state = {
  bdxFilters: defaultState().bdxFilters,
  userCompanyRLS: defaultState().userCompanyRLS
}

const getters = {
  bdxFilters: (state) => state.bdxFilters,
  userCompanyRLS: (state) => state.userCompanyRLS
}

const actions = {}

const mutations = {
  SET_BDX_FILTER: (state, filter) => {
    if (!filter.key) return

    state.bdxFilters[filter.key] = filter.value
  },
  UNSET_BDX_FILTER: (state, key) => {
    state.bdxFilters[key] = null
  },

  SET_USER_COMPANY_RLS: (state, companyRLS) => {
    state.userCompanyRLS.id = companyRLS.id || null
    state.userCompanyRLS.slipshare = companyRLS.slipshare || null
  },
  UNSET_USER_COMPANY_RLS: (state) => {
    state.userCompanyRLS = {
      id: null,
      slipshare: null
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
